import React from 'react'

export function useCallbackRef<T>(initializer?: (element: T) => void) {
  const elementRef = React.useRef<T | null>(null)
  const callbackRef: React.RefCallback<T> = React.useCallback((element) => {
    if (element === null) {
      return
    }

    elementRef.current = element
    if (initializer) {
      initializer(element)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { callbackRef, elementRef }
}
